import React from "react";
import { useAuth } from "../../context/AuthContext";
import { useProjects } from "../../context/ProjectsContext";
import ClientCommandCenter from "../../components/dashboard/ClientCommandCenter";

export default function DashboardHomePage() {
  const { user } = useAuth();
  const {
    projects,
    activeProject,
    setActiveProject,
    projectCreation,
    loadProjects,
    loading,
    error,
  } = useProjects();

  React.useEffect(() => {
    loadProjects();
  }, [loadProjects]);

  return (
    <ClientCommandCenter
      user={user}
      projects={projects}
      activeProject={activeProject}
      setActiveProject={setActiveProject}
      projectCreation={projectCreation}
      loading={loading}
      error={error}
    />
  );
}
